import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl";
import MoreInfo from "./MoreInfo";
import SACheckbox from "../common/input/SACheckbox";
import SAButton from '../common/button/SAButton';
import {Card, Col, Row} from 'antd';


class ConsentForm extends Component {

  componentDidMount() {
    this.props.dispatchFetchPolicyDocument();
  }

  onCheckboxChange = (event, node) => {
    const {checked} = event.target;
    const value = checked ? 'ACCEPT' : 'REJECT';
    this.props.dispatchAddPolicyDocumentConsent({...node, value});
  };

  onSaveConsent = (e) => {
    e.preventDefault();
    const {policyDocument} = this.props;
    let {consents} = this.props;
    if (consents && consents.length) {
      const implicitConsents = policyDocument.usageDefinitions && policyDocument.usageDefinitions.filter(usage => usage.consents && usage.consents.some(consent => consent.variant === 'IMPLICIT'));
      if (implicitConsents && implicitConsents.length) {
        const response = implicitConsents.map(consent => ({
          ...consent,
          value: consents.some(consent => consent.value === 'ACCEPT') ? 'ACCEPT' : 'REJECT'
        }));
        consents = [...consents, ...response];
      }
    }
    this.props.dispatchSavePolicyDocumentConsent({consents});
  }

  render() {
    const {intl: {formatMessage}, policyDocument} = this.props;
    if (!policyDocument || !policyDocument.usageTexts.length || !policyDocument.usageDefinitions.length) {
      return null;
    }
    if (policyDocument && policyDocument.previousConsent === true) {
      return null;
    }
    return (
      <Card xclassName={"pt-5 my-5"} style={{paddingBottom: 0, overflow: 'hidden', marginBottom: '30px'}}
            title={<h3
              style={{float: 'left', fontWeight: 'bold', fontSize: 16}}>{formatMessage({id: 'consent.title'})}</h3>}
            bordered>
        <form onSubmit={this.onSaveConsent}>
          <h3 className={"text-normal mt-4"} dangerouslySetInnerHTML={{__html: policyDocument.usageTexts[0].value}}/>

          {policyDocument.usageDefinitions.filter(node => node.consents.some(consent => consent.variant !== 'IMPLICIT')).map(node => {
            return <div key={node.id} className={"form-field--inline justify-content-start"}>
              <SACheckbox id={`consent-${node.id}`} onChange={value => {
                this.onCheckboxChange(value, node)
              }}/>
              <label className="pl-4 mb-2" htmlFor={`consent-${node.id}`}>
                <span className="sr-only">{formatMessage({id: 'sr.select.consent'})}</span>
                <span dangerouslySetInnerHTML={{__html: node.primaryValue}}/>
                <MoreInfo text={node.secondaryValue}/>
              </label>
            </div>
          })}
          <div>
            <span dangerouslySetInnerHTML={{__html: policyDocument.usageTexts[1].value}}/>
            <MoreInfo text={policyDocument.usageTexts[2].value}/>
          </div>
          <Row type="flex" justify={"end"} className={"mt-3"}>
            <Col span={8}>
              <SAButton htmlType="submit" type="primary">
                {formatMessage({id: 'action.save'})}
              </SAButton>
            </Col>
          </Row>
        </form>
      </Card>
    )
  }
}

const mapStateToProps = (state) => ({
  policyDocument: state.policyDocument && state.policyDocument.body,
  consents: state.policyDocument && state.policyDocument.consents,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchAddPolicyDocumentConsent: (params) => dispatch({type: 'ADD.POLICY_DOCUMENT_CONSENT.REQUEST', params}),
  dispatchFetchPolicyDocument: (params, body) => dispatch({type: 'FETCH.POLICY_DOCUMENT.REQUEST', params, body}),
  dispatchSavePolicyDocumentConsent: (params) => dispatch({type: 'SAVE.POLICY_DOCUMENT_CONSENT.REQUEST', params}),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ConsentForm));
